// extracted by mini-css-extract-plugin
module.exports = {"container":"ModuleSettingsTab_container__34CPQ","checkboxContainer":"ModuleSettingsTab_checkboxContainer__2zLFC","inputElement":"ModuleSettingsTab_inputElement__3ID5W"};